<div class="amount-card">
  <div *ngIf="setAmount(raised)" class="amount">
    <div *ngIf="vwoService.getTickrVariable() && fundraiser?.raised?.backers && fundraiser?.raised?.beforeTickrBackers>10 && !isFundraiserEnded; else lessBackers">
      <div *ngIf="showRaisedAmt">
        <app-currency-icon *ngIf="currency" [currency]="currency"></app-currency-icon>
        <!--Counto directive to animate number -->
        <span counto
          step="30"
          [countTo]="raised"
          [countFrom]="fundraiser.raised.beforeTickr ? fundraiser.raised.beforeTickr : raised"
          (countoChange)="counto = $event" duration="1">
          {{ counto  | inrFormat:currency}}
        </span>
      </div>
      <app-placeholder-loader *ngIf="!showRaisedAmt" type="text" [count]="1"></app-placeholder-loader>
    </div>
    <ng-template #lessBackers>
      <div>
        <app-currency-icon *ngIf="currency" [currency]="currency"></app-currency-icon>
        {{(raised?raised:'0') | inrFormat:currency}}
      </div>
    </ng-template>
  </div>
  <span *ngIf="currency && (goal || raised) && !fundraiser?.is_multi_patient_campaign" class="raised">
    <span *ngIf="raised">{{isFundraiserEnded || !goal ? 'raised':'raised of'}}</span>&nbsp;
    <span *ngIf="!isFundraiserEnded && goal && goal!==0">
      <span *ngIf="currency" class="numbers">
        <app-currency-icon [currency]="currency"></app-currency-icon>
        {{goal | inrFormat:currency}}
      </span> goal
    </span>
  </span>
  <div class="multipatient" *ngIf="fundraiser?.is_multi_patient_campaign">
    <div class="text">Raised for {{beneficiaryName}} and other patients in need </div>
    <div class="icon">
      <em class="material-icons">info</em>
      <span class="tooltiptext">
        <div class="header">One donation, many helped</div>
        <div class="horizontalline"></div>
        <div class="sub">Today's a special day! Your donation right now will help {{beneficiaryName}} and others fighting a similar illness. This is truly a remarkable deed, thank you.</div>
      </span>
    </div>
  </div>
  <div class="progressbar">
    <app-progress-bar *ngIf="!isFundraiserEnded && setAmount(raised) && goal && goal!==0 && !fundraiser?.is_multi_patient_campaign" [amount]="raised" [goal]="goal" height="12px"></app-progress-bar>
  </div>
  <div class="amount-footer">
    <span *ngIf="!fundraiser?.settings?.nodonorlist" class="raised supporters"> <span class="numbers">{{supporters?supporters:0}}</span> supporters</span>
    <span *ngIf="!isFundraiserEnded && date && !fundraiser?.settings?.hidedaysleft" class="raised supporters">
      <span *ngIf="(date | dayjs:'diffInDays') >= 0" class="numbers">{{+(date | dayjs:'diffInDays') + 1}}</span> days left
    </span>
  </div>
</div>
